import fs from "fs";
import path from "path";

export const refundTemplatesDirectoryPath = ln => global.isProd
    ? `buildServer/server/models/fncs/mails/templates/${ln}/refund`
    : `src/server/models/fncs/mails/templates/${ln}/refund`
export const invoiceTemplatesDirectoryPath = ln => global.isProd
    ? `buildServer/server/models/fncs/mails/templates/${ln}/invoice`
    : `src/server/models/fncs/mails/templates/${ln}/invoice`

export const reallocationTemplatesDirectoryPath = ln => global.isProd
    ? `buildServer/server/models/fncs/mails/templates/${ln}/reallocation`
    : `src/server/models/fncs/mails/templates/${ln}/reallocation`

function base64Encode(file) {
    return fs.readFileSync(file, {encoding: 'base64'});
}

export const getBase64EncodedUrlImage = function (fileName) {
    const imagePath = path.join(global.appRoot, global.isProd ? "buildServer/img" : "src/img", fileName);
    const bas64 = base64Encode(imagePath)
    const src = `data:image/png;base64,${bas64}`
    return `<img src="${src}" alt="logo" width="24" style="vertical-align:text-bottom;display:inline-block;width:24px;height:auto;border:0;"/>`;
}
